import { render, staticRenderFns } from "./ButtonComponent.vue?vue&type=template&id=31007195&scoped=true&"
import script from "./ButtonComponent.vue?vue&type=script&lang=js&"
export * from "./ButtonComponent.vue?vue&type=script&lang=js&"
import style0 from "./ButtonComponent.vue?vue&type=style&index=0&id=31007195&prod&lang=scss&scoped=true&"
import style1 from "./ButtonComponent.vue?vue&type=style&index=1&id=31007195&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31007195",
  null
  
)

export default component.exports